

<div class="shortcode-form">
    <label appLabel>
        Enter your client shortcode to continue
        <input appInput type="text" [formControl]="clientShortcode">
    </label>

    <button appButton fullwidth (click)="continue()" [disabled]="clientShortcode.invalid || loading">
        Continue
    </button>
</div>

